/**
 * Register the hand-rolled service worker (public/sw.js) so the kiosk is
 * installable (standalone) and boots offline. Best-effort: a failure to register
 * never blocks the app — the offline queue works regardless.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error: unknown) => {
      // eslint-disable-next-line no-console
      console.warn('[worklogix-kiosk] service worker registration failed:', error);
    });
  });
}
